/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive } from "@angular/core";
var IconCustomTag = (function () {
    function IconCustomTag() {
    }
    return IconCustomTag;
}());
export { IconCustomTag };
// No behavior
// The only purpose is to "declare" the tag in Angular
IconCustomTag.decorators = [
    { type: Directive, args: [{ selector: "clr-icon" },] },
];
/** @nocollapse */
IconCustomTag.ctorParameters = function () { return []; };
//# sourceMappingURL=icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/icon/icon.js
// module id = 297
// module chunks = 4